import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
open(event) {
  const cardId = event.currentTarget.dataset.cardId
  const template = document.getElementById(`epiphany-variants-${cardId}`)
  if (!template) return

  const container = document.getElementById("epiphany-modal-cards")
  container.innerHTML = ""

  Array.from(template.children).forEach(child => {
    const clone = child.cloneNode(true)
    clone.classList.remove("hidden")
    clone.style.display = "block"
    clone.querySelectorAll(".hidden").forEach(el => el.classList.remove("hidden"))
    container.appendChild(clone)
  })

  console.log("container children:", container.children.length)
  console.log("container HTML:", container.innerHTML.substring(0, 200))

  document.getElementById("epiphany-modal").classList.remove("hidden")
  document.body.style.overflow = "hidden"
}

  close() {
    document.getElementById("epiphany-modal").classList.add("hidden")
    document.body.style.overflow = ""
  }
}
